import { createStyles, makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    editButton: {
      padding: 0,
      minWidth: 40,
      width: 40,
      '& svg': {
        width: 16,
        height: 16,
      },
    },
    table: {
      borderCollapse: 'separate',
      fontSize: 14,
      '& .MuiTableCell-sizeSmall': {
        padding: '6px 16px',
        color: variables.richBlack,
      },
    },
    emptyMessage: {
      paddingTop: 20,
      paddingBottom: 20,
      fontStyle: 'italic',
    },
    partnershipCard: {
      height: 19,
      borderRadius: 4,
      paddingRight: 4,
      paddingLeft: 4,
      marginRight: 4,
      backgroundColor: variables.black5,
      color: variables.richBlack,
      boxShadow: 'none',
      fontSize: 12,
      width: 'fit-content',
    },
    defaultRule: {
      fontWeight: 600,
      textTransform: 'uppercase',
    },
    infoIcon: {
      transform: 'scale(0.9)',
    },
  }),
);
